import { connect, ConnectedProps } from 'react-redux';
import { RootState } from '../../../../../../../../store/root-reducer';
import PhoneNumberFiltersModal, {
  PhoneNumberFilters,
} from './phone-number-filters-modal';

const mapStateToProps = (state: RootState) => ({
  teamMembersList: state.dialer.teamMembersList,
  countriesOptionsForNumbersSearch: state.dialer.countryCodeOptionsListForFilters,
  regionOptionsListForFilters: state.dialer.regionOptionsListForFilters,
});

const connector = connect(mapStateToProps);

export type IProps = ConnectedProps<typeof connector> & {
  show: boolean;
  onClose: VoidFunction;
  phoneNumberFilters: PhoneNumberFilters;
  onFiltersChange: (filters: PhoneNumberFilters) => void;
};

export default connector(PhoneNumberFiltersModal);
